import { cn } from '@ordo/ui/cn'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@ordo/ui/tooltip'
import { Check } from 'lucide-react'

import { USER_AVATAR_COLORS, type UserAvatarColor } from '@/lib/user-avatar-colors'

export interface UserAvatarColorPickerProps {
  value: UserAvatarColor
  onChange: (value: UserAvatarColor) => void
  label?: string
  className?: string
}

export function UserAvatarColorPicker({
  value,
  onChange,
  label = 'Icon color',
  className,
}: UserAvatarColorPickerProps) {
  return (
    <div className={className}>
      <p className="typo-label text-muted-foreground">{label}</p>
      <TooltipProvider delayDuration={150}>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {USER_AVATAR_COLORS.map((option) => {
            const selected = option.value === value
            return (
              <Tooltip key={option.value}>
                <TooltipTrigger asChild>
                  <button
                    type="button"
                    aria-label={`${option.label} icon color`}
                    aria-pressed={selected}
                    onClick={() => onChange(option.value)}
                    className={cn(
                      'flex h-7 w-7 items-center justify-center rounded-full border border-transparent transition-shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
                      selected && 'ring-2 ring-ring ring-offset-2',
                    )}
                    style={{ backgroundColor: option.hex }}>
                    {selected ? <Check className="h-4 w-4 text-white" aria-hidden /> : null}
                  </button>
                </TooltipTrigger>
                <TooltipContent>{option.label}</TooltipContent>
              </Tooltip>
            )
          })}
        </div>
      </TooltipProvider>
    </div>
  )
}
